export default "__VITE_ASSET__a005346d__"